import * as React from 'react';
import { useTranslation } from 'react-i18next';

// ─── Types ────────────────────────────────────────────────────────────────────

export const APP_LOGO_VARIANT = {
  BLACK: 'black',
  ICON_WHITE: 'icon-white',
  WHITE: 'white',
} as const;
export type AppLogoVariant = (typeof APP_LOGO_VARIANT)[keyof typeof APP_LOGO_VARIANT];

export interface AppLogoProps {
  className?: string;
  /** Renders with an empty alt when the logo is purely decorative (e.g. alongside visible heading text). */
  decorative?: boolean;
  variant: AppLogoVariant;
}

// ─── Constants ────────────────────────────────────────────────────────────────

const LOGO_FILE_BY_VARIANT: Record<AppLogoVariant, string> = {
  [APP_LOGO_VARIANT.BLACK]: 'klareo-go-logo-black.png',
  [APP_LOGO_VARIANT.ICON_WHITE]: 'klareo-go-logo-sm-white.png',
  [APP_LOGO_VARIANT.WHITE]: 'klareo-go-logo-white.png',
};

// ─── Component ────────────────────────────────────────────────────────────────

/** The KLAREO Go wordmark/icon, resolved from `public/` per variant. Sizing comes from `className`. */
export function AppLogo({ className, decorative = false, variant }: AppLogoProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <img
      alt={decorative ? '' : t('app.logoAlt')}
      className={className}
      src={`${import.meta.env.BASE_URL}${LOGO_FILE_BY_VARIANT[variant]}`}
    />
  );
}
